import { createFileRoute, Navigate } from "@tanstack/react-router";

// Redirect alias (kept one release, house convention): password change now lives on the
// Security tab of Account settings instead of its own island.
export const Route = createFileRoute("/(app)/dashboard/settings/change-password")({
  component: () => <Navigate to="/dashboard/settings/security" replace />,
});
